export const categoriesConsts = {
    GET_CATEGORIES_LIST: "GET_CATEGORIES_LIST",
    CREATE_CATEGORY: "CREATE_CATEGORY",
    UPDATE_CATEGORIES_POSITIONS: "UPDATE_CATEGORIES_POSITIONS",
    UPDATE_CATEGORY_BY_ID: "UPDATE_CATEGORY_BY_ID",
    DELETE_CATEGORY_BY_ID: "DELETE_CATEGORY_BY_ID",
};